import React from 'react';

const CreditBalance = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold">Credit Balance</h2>
        <p className="text-sm text-slate-500">Available credits you can use at checkout.</p>
      </div>

      <div className="p-6 rounded-md border bg-gradient-to-r from-slate-900 to-slate-700 text-white">
        <p className="text-sm opacity-80">Available Balance</p>
        <p className="text-3xl font-bold mt-1">0.00</p>
        <p className="text-xs opacity-70 mt-3">Credits will be applied automatically when eligible.</p>
      </div>

      <div className="border rounded-md bg-white">
        <div className="p-4 border-b">
          <h3 className="font-semibold">Credit History</h3>
        </div>
        <div className="p-6 text-sm text-slate-500">
          No credit history yet.
        </div>
      </div>
    </div>
  );
};

export default CreditBalance;
